<template>
  <div class="servicios m-0 p-0">
    <div class="row w-100 m-0 shadow">
      <div
        class="col-12 col-md-6 col-lg-4 p-0"
        v-for="(item,index) in NuestrosServicios"
        :key="index"
      >
        <div class="contenedor-servicio">
          <img :title="item.nombre" :src="item.imagen" />
          <div
            class="contenedor-titulo-servicio d-flex align-items-center flex-wrap justify-content-center w-100 px-2 px-xl-3"
          >
            <div>
              <h1 class="pt-1 px-2">{{item.nombre}}</h1>
              <p class="py-0 px-2">{{item.descripcion}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      NuestrosServicios: [
        {
          nombre: "Aplicaciones de Escritorio",
          descripcion:
            "Trabajamos con aplicaciones instaladas en el ordenador o sistema de almacenamiento que pueden ser ejecutados sin internet",
          imagen: require("@/assets/images/iconos_servicios/aplicaciones_escritorio.jpeg")
        },
        {
          nombre: "Aplicaciones Móviles",
          descripcion:
            "Desarrollo de aplicaciones móviles diseñadas para ser ejecutadas en teléfonos inteligentes, tabletas y otros dispositivos",
          imagen: require("@/assets/images/iconos_servicios/aplicaciones_moviles.jpeg")
        },
        {
          nombre: "Aplicaciones Web",
          descripcion:
            "Diseñamos y desarrollamos proyectos web para el manejo de operaciones online",
          imagen: require("@/assets/images/iconos_servicios/aplicaciones_web.jpeg")
        },
        {
          nombre: "Backups",
          descripcion:
            "Ofrecemos a nuestros clientes el servicio de backup y monitoreo de sus datos en bancos de servidores fuera de sus instalaciones",
          imagen: require("@/assets/images/iconos_servicios/backups.jpeg")
        },
        {
          nombre: "Consultoría",
          descripcion:
            "Brindamos un servicio de asesoramiento en la gestión y estrategia futura de problemas administrativos",
          imagen: require("@/assets/images/iconos_servicios/consultoria.jpeg")
        },
        {
          nombre: "Plataformas eCommerce",
          descripcion: "Desarrollamos tu sucursal online",
          imagen: require("@/assets/images/iconos_servicios/ecommerce.jpeg")
        }
      ]
    };
  }
};
</script>
<style scoped>
.servicios {
  background: #262626;
}
.seccion-servicios {
  height: 100%;
  background: rgba(0, 0, 0, 0.21);
}
.contenedor-servicio {
  height: 320px;
  position: relative !important;
}
h1 {
  font-size: calc(1.2em + 1vw);
}
p {
  font-size: calc(0.7em + 0.5vw);
}
img {
  height: 320px;
  width: 100%;
  opacity: 1;
  object-fit: cover;
}
@media screen and (max-width: 1280px) {
  .contenedor-servicio,
  img {
    height: 260px;
  }
}
@media screen and (max-width: 768px) {
  .contenedor-servicio,
  img {
    height: 240px;
  }
  p {
    font-size: calc(0.9em + 0.5vw);
  }
}
.contenedor-titulo-servicio {
  position: absolute;
  bottom: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  transition: all 0.3s;
}
.contenedor-titulo-servicio:hover {
  cursor: default;
  background: #009cff;
  color: white;
  opacity: 0.92;
}
</style>